<template>
  <div class="shared-reset-list">
    <div class="search-title">
      <span class="fa fa-search" @click="searchSharedResets($event)" />
      <input-control
        v-model="searchTextSavedResetsInput"
        type="text"
        :no-title="true"
        name="search_title"
        :placeholder="$t('reset.placeholder.name_title_reset')"
        :class="{'search-title-text': true, 'full-text': showOnlyFriends}"
        @keypress="onEnter($event, searchSharedResets)"
      />
    </div>
    <div class="search-etc">
      <select v-if="!showOnlyFriends" v-model="searchSexdstnCodeInput" class="simple-design" name="sex_distinction">
        <option value="">
          {{ $t('calculator.placeholder.sex_distinction') }}
        </option>
        <option v-for="(sexdstnCode, sexdstnCodeIndex) in sexdstnCodes" :key="'sex-distinct-code-' + sexdstnCodeIndex" :value="sexdstnCode.codeId">
          {{ $t('code.nm.' + sexdstnCode.codeId) }}
        </option>
      </select>
      <select v-if="!showOnlyFriends" v-model="searchAgeCodeInput" class="simple-design" name="age_code">
        <option value="">
          {{ $t('calculator.placeholder.age') }}
        </option>
        <option v-for="(ageCode, ageCodeIndex) in ageCodes" :key="'age-' + ageCodeIndex" :value="ageCode.codeId">
          {{ $t('code.nm.' + ageCode.codeId) }}
        </option>
      </select>
    </div>
    <div class="sorting-area">
      <span :class="{'sort-item': true, 'selected': sharedResetOrder === 'userNm'}" @click="clickResetOrder('userNm', $event)">{{ $t('reset.sort.title') }} <span><i :class="'fa fa-play ' + sharedResetDirection" /></span></span>
      <span :class="{'sort-item': true, 'selected': sharedResetOrder === 'bgnde'}" @click="clickResetOrder('bgnde', $event)">{{ $t('reset.sort.time') }} <span><i :class="'fa fa-play ' + sharedResetDirection" /></span></span>
      <span v-if="!showOnlyFriends" :class="{'sort-item': true, 'selected': sharedResetOrder === 'likeCo'}" @click="clickResetOrder('likeCo', $event)">{{ $t('reset.sort.like_co') }} <span><i :class="'fa fa-play ' + sharedResetDirection" /></span></span>
      <span v-if="!showOnlyFriends" :class="{'sort-item': true, 'selected': sharedResetOrder === 'amount'}" @click="clickResetOrder('amount', $event)">{{ $t('reset.sort.amount') }} <span><i :class="'fa fa-play ' + sharedResetDirection" /></span></span>
    </div>
    <div class="shared-resets-list-container" @scroll="onScrollSavedResets">
      <div v-if="sharedResetsTotal === 0" class="no-data">
        {{ $t('common.text.no_data') }}
      </div>
      <div v-else-if="$route.query.submenu=='reset_friends'" class="shared-resets-list-wrapper">
        <div v-for="(sharedReset, sharedResetIndex) in sharedResets" :key="'shared-reset-' + sharedResetIndex" class="reset-item shared-reset-item friends-reset-item" @click="selectSavedReset(sharedReset, $event)">
          <div class="name">
            {{ sharedReset.userNm }}
          </div>
          <div class="title">
            {{ sharedReset.nm }}
          </div>
          <div class="date">
            {{ sharedReset.bgnde }} ~ {{ sharedReset.endde }}
          </div>
        </div>
        <div class="clear" />
        <div v-if="sharedResetsTotal !== undefined && sharedResetsTotal > sharedResetsLoaded" class="shared-resets-loading resets-loading">
          <div class="clear" />
          <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
          <strong>{{ $t('common.text.loading') }}</strong>
        </div>
      </div>
      <div v-else class="shared-resets-list-wrapper">
        <div v-for="(sharedReset, sharedResetIndex) in sharedResets" :key="'shared-reset-' + sharedResetIndex" class="reset-item shared-reset-item public-shared-reset-item" @click="selectSavedReset(sharedReset, $event)">
          <div class="public-shared-title">
            <img class="reset-editor-icon person" src="/img/icons/ic_inbody.png" alt="Info">
            <div class="title">
              {{ sharedReset.nm }}
            </div>
            <div class="intake-rate">
              {{ $t('reset.text.intake_rate') }} : {{ getIntakeRate(sharedReset) }}%
            </div>
          </div>
          <div class="reset-images-area">
            <div class="reset-images-container before-images">
              <div class="before-title">
                {{ $t('reset.text.before') }}
              </div>
              <div class="reset-images">
                <div class="image-container">
                  <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(sharedReset.beginFrontImages)" alt="$t('reset.editor.front_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefBeginFrontImages-' + sharedResetIndex, $event)" />
                  <image-viewer v-if="sharedReset && sharedReset.beginFrontImages" :ref="'imageViewerRefBeginFrontImages-' + sharedResetIndex" :src="getImgUrl(sharedReset.beginFrontImages, 1600)" :alt="$t('reset.editor.front_image')" />
                </div>
                <div class="image-container">
                  <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(sharedReset.beginSideImages)" alt="$t('reset.editor.side_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefBeginSideImages-' + sharedResetIndex, $event)" />
                  <image-viewer v-if="sharedReset && sharedReset.beginSideImages" :ref="'imageViewerRefBeginSideImages-' + sharedResetIndex" :src="getImgUrl(sharedReset.beginSideImages, 1600)" :alt="$t('reset.editor.side_image')" />
                </div>
              </div>
            </div>
            <div class="reset-images-container result-images">
              <div class="result-title">
                {{ $t('reset.text.after') }}
              </div>
              <div class="reset-images">
                <div class="image-container">
                  <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(sharedReset.resultFrontImages)" alt="$t('reset.editor.front_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefResultFrontImages-' + sharedResetIndex, $event)" />
                  <image-viewer v-if="sharedReset && sharedReset.resultFrontImages" :ref="'imageViewerRefResultFrontImages-' + sharedResetIndex" :src="getImgUrl(sharedReset.resultFrontImages, 1600)" :alt="$t('reset.editor.front_image')" />
                </div>
                <div class="image-container">
                  <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(sharedReset.resultSideImages)" alt="$t('reset.editor.side_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefResultSideImages-' + sharedResetIndex, $event)" />
                  <image-viewer v-if="sharedReset && sharedReset.resultSideImages" :ref="'imageViewerRefResultSideImages-' + sharedResetIndex" :src="getImgUrl(sharedReset.resultSideImages, 1600)" :alt="$t('reset.editor.side_image')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear" />
        <div v-if="sharedResetsTotal !== undefined && sharedResetsTotal > sharedResetsLoaded" class="shared-resets-loading resets-loading">
          <div class="clear" />
          <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
          <strong>{{ $t('common.text.loading') }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: {
      type: Object,
      default: undefined
    },
    initConditions: {
      type: Object,
      default: undefined
    },
    showOnlyFriends: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sharedResets: undefined,
      sharedResetFirstId: undefined,
      sharedResetsTotal: undefined,
      sharedResetsLoaded: undefined,
      searchTextSavedResetsInput: '',
      sharedResetOrder: 'bgnde',
      sharedResetDirection: 'desc',
      searchSexdstnCodeInput: '',
      searchAgeCodeInput: '',
      searchReasonsForInputControlInput: [],
      reasonOptions: [],
      sexdstnCodes: [],
      ageCodes: []
    }
  },
  watch: {
    searchTextSavedResetsInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    sharedResetOrder: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    sharedResetDirection: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    searchSexdstnCodeInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    searchAgeCodeInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    searchReasonsForInputControlInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    }
  },
  async mounted() {
    this.ageCodes = await this.getCodes('age')
    this.sexdstnCodes = await this.getCodes('sex_distinction')
    this.resetReasonCodes = await this.getCodes('reset_reason')
    for (let i = 0; i < this.resetReasonCodes.length; i++) {
      const code = this.resetReasonCodes[i]
      this.reasonOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }
    if (this.initConditions) {
      for (const key in this.initConditions) {
        this[key] = this.initConditions[key]
      }
      if (this.initData) {
        this.initializeWithData()
        return
      }
      this.searchSharedResets()
    } else {
      if (this.initData) {
        this.initializeWithData()
        return
      }
      this.loadSharedResets(true)
    }
  },
  methods: {
    showPreimageViewer: function(ref, e) {
      this.vibrate(e)
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
      if (
        this.$refs &&
        this.$refs[ref] &&
        this.$refs[ref].length > 0 &&
        this.$refs[ref][0]
      ) {
        this.$refs[ref][0].showImageViewer()
      }
    },
    emitConditions() {
      this.$emit('condition-changed', {
        searchTextSavedResetsInput: this.searchTextSavedResetsInput,
        sharedResetOrder: this.sharedResetOrder,
        sharedResetDirection: this.sharedResetDirection,
        searchSexdstnCodeInput: this.searchSexdstnCodeInput,
        searchAgeCodeInput: this.searchAgeCodeInput,
        searchReasonsForInputControlInput: this
          .searchReasonsForInputControlInput
      })
    },
    selectSavedReset(reset, e) {
      this.$emit('select-reset', {
        reset: reset,
        e: e
      })
    },
    searchSharedResets(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.searchTextSavedResets = this.searchTextSavedResetsInput
      this.searchSexdstnCode = this.searchSexdstnCodeInput
      this.searchAgeCode = this.searchAgeCodeInput
      this.searchReasonsForInputControl = this.searchReasonsForInputControlInput
      this.loadSharedResets(true)
    },
    clickResetOrder(order, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (order === this.sharedResetOrder) {
        if (this.sharedResetDirection === 'asc') {
          this.sharedResetDirection = 'desc'
        } else {
          this.sharedResetDirection = 'asc'
        }
      } else {
        this.sharedResetDirection = 'desc'
        this.sharedResetOrder = order
      }
      this.loadSharedResets(true)
    },
    async loadSharedResets(refresh) {
      if (refresh) {
        this.sharedResets = undefined
        this.sharedResetFirstId = undefined
        this.sharedResetsTotal = undefined
        this.sharedResetsLoaded = 0
        window.sharedResetsPage = -1
      }
      if (this.sharedResetsTotal === this.sharedResetsLoaded) {
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      window.sharedResetsPage++
      let url = '/reset/resets?myFlag=N&pageNo=' + window.sharedResetsPage
      if (this.sharedResetFirstId) {
        url += '&firstId=' + this.sharedResetFirstId
      }
      if (this.searchTextSavedResets) {
        url += '&searchText=' + encodeURIComponent(this.searchTextSavedResets)
      }
      if (this.searchSexdstnCode) {
        url += '&searchSexdstnCode=' + this.searchSexdstnCode
      }
      if (this.searchAgeCode) {
        url += '&searchAgeCode=' + this.searchAgeCode
      }
      if (
        this.searchReasonsForInputControl &&
        this.searchReasonsForInputControl.length > 0
      ) {
        for (let i = 0; i < this.searchReasonsForInputControl.length; i++) {
          const value = this.searchReasonsForInputControl[i].value
          url += '&searchReasons=' + encodeURIComponent(value)
        }
      }
      if (this.showOnlyFriends) {
        url += '&showOnlyFriendsFlag=Y'
      } else {
        url += '&shareFlag=Y&withImages=Y'
      }
      url +=
        '&order=' +
        encodeURIComponent(this.sharedResetOrder) +
        '&direction=' +
        this.sharedResetDirection
      const res = await this.$axios.$get(url)
      if (!this.sharedResets) {
        this.sharedResets = res.data.list
      } else {
        this.sharedResets = this.sharedResets.concat(res.data.list)
      }
      this.sharedResetsTotal = res.data.totalSize
      if (!this.sharedResetFirstId) {
        this.sharedResetFirstId = res.data.firstId
      }
      if (this.sharedResets) {
        this.sharedResetsLoaded = this.sharedResets.length
      }
      this.$nextTick(() => {
        this.loading = false
        this.onScrollSavedResets()
      })
    },
    emitScrollAndData() {
      this.$emit('scroll-and-data', {
        list: this.sharedResets,
        total: this.sharedResetsTotal,
        firstId: this.sharedResetFirstId,
        loaded: this.sharedResetsLoaded,
        scrolledY: this.scrolledY
      })
    },
    initializeWithData() {
      this.sharedResets = this.initData.list
      this.sharedResetsTotal = this.initData.total
      this.sharedResetFirstId = this.initData.firstId
      this.sharedResetsLoaded = this.initData.loaded
      this.$nextTick(() => {
        $(this.$el)
          .find('.shared-resets-list-container')
          .scrollTop(this.initData.scrolledY)
      })
    },
    onScrollSavedResets(e) {
      const comp =
        $('.shared-resets-list-wrapper').height() -
        $('.shared-resets-list-container').height()
      const top = $('.shared-resets-list-container').scrollTop()
      if (comp - top < 50) {
        this.loadSharedResets(false)
      }
      this.scrolledY = top
      this.emitScrollAndData()
    }
  }
}
</script>

<style scoped>
.shared-reset-list {
  padding: 0;
}
.shared-resets-list-container {
  height: calc(100vh - 22.5rem);
  overflow-y: auto;
  overflow-x: hidden;
}

.search-title .fa {
  color: #360ea6;
  font-size: 1.5rem;
  margin-left: 1.708333333333333rem;
  position: absolute;
  z-index: 4;
}
.search-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.708333333333333rem;
  background: #f1f1f1;
}
.search-title {
  padding: 1rem 0;
}
.search-title >>> input[type='text']::placeholder,
.search-title >>> input[type='text'] {
  font-size: 0.95rem !important;
}
.search-title >>> input[type='text'] {
  padding: 0 0.7rem;
  padding-left: 2.6rem;
  height: 2.291666666666667rem;
}
.search-title-text {
  height: 2.291666666666667rem;
  border: none;
  margin-left: 1rem;
  width: calc(100vw - 2rem);
}
.search-title-text >>> input {
  border: none !important;
  box-shadow: none !important;
}
.reset-item .name {
  font-weight: bold;
}
.reset-item .title {
  font-weight: lighter;
  overflow: hidden;
  line-height: 1.2rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.reset-item .title .title-content {
  max-width: 65%;
  max-height: 2rem;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  text-align: center;

  word-wrap: break-word;
  display: block;
  -webkit-line-clamp: 2; /* ellipsis line */
  -webkit-box-orient: vertical;
  white-space: nowrap;
  margin-top: 0.4rem;

  /* webkit 엔진을 사용하지 않는 브라우저를 위한 속성. */
  /* height = line-height * line = 1.2em * 3 = 3.6em  */
  line-height: 1rem;
  font-size: 1rem;
}
.reset-item .name,
.reset-item .title {
  font-size: 0.95rem;
}
.reset-item .registration-operation-date {
  font-size: 0.95rem;
  width: 9.3rem;
}
.reset-item .name-and-title {
  width: calc(100% - 9.3rem);
}
.resets-loading {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.no-data {
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10rem;
}
.search-etc {
  float: left;
  padding: 0.5rem 1rem;
}
.selectors {
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.selectors > select {
  margin-right: 0.4rem;
}
.reset-reason-select {
  width: calc(100% - 11.33rem);
  margin-right: 0 !important;
}
.shared-reset-item {
  float: left;
  width: calc(100% / 3);
  margin-bottom: 1rem;
}
.shared-reset-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.shared-reset-item .title {
  width: 6.8583rem;
  height: 3.4291rem;
  border-top-left-radius: 3.4291rem;
  border-top-right-radius: 3.4291rem;
  background-color: #03d5ca;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
}
.shared-reset-item .date {
  width: 6.8583rem;
  height: 3.4291rem;
  border-bottom-left-radius: 3.4291rem;
  border-bottom-right-radius: 3.4291rem;
  background-color: #dbdbdb;
  padding-top: 1rem;
  text-align: center;
  color: #999999;
  font-size: 0.95rem;
  letter-spacing: -0.1rem;
}
.shared-reset-item .name {
  font-size: 0.95rem;
  padding: 0.3rem 0;
}
.shared-reset-item:nth-child(2n) .title {
  background-color: #01a3fc;
}
.shared-reset-item:nth-child(3n + 1) {
  clear: both;
}
.shared-reset-item .summary-data {
  font-weight: lighter;
  font-size: 0.95rem;
  line-height: 1.2rem;
  color: #999999;
}
select.simple-design {
  background-position: calc(100% - 0.6rem) 0.76rem, calc(100% - 0.2rem) 0.76rem,
    calc(100% - 1.3rem) 0;
  background-size: 0.416rem 0.416rem, 0.416rem 0.416rem, 1px 2.2rem;
  height: 1.958333333333333rem;
}
.sorting-area .fa-play {
  transform: rotate(270deg);
}
.sorting-area .selected .fa-play.desc {
  transform: rotate(90deg);
}
.sorting-area {
  color: #e5e5e5;
  font-size: 0.825rem;
  padding: 0 1rem;
  margin-bottom: 1rem;
}
.sorting-area .selected {
  color: #360ea6;
}
.sort-item {
  margin-right: 1rem;
}
.sort-item .fa {
  margin-left: 0.5rem;
}
>>> input {
  z-index: 1;
}

.image-container {
  width: 6.416666666666667rem;
  height: 6.416666666666667rem;
  overflow: hidden;
  background-color: rgb(53, 53, 53, 0.1);
}
.image-container >>> .default-image {
  width: 1.833333333333333rem !important;
  height: 2.066666666666667rem !important;
  margin-top: calc(50% - 1.033333333333333rem) !important;
  margin-left: calc(50% - 0.916666666666667rem) !important;
}
.friends-reset-item.shared-reset-item {
  display: flex;
  flex-direction: row;
  width: calc(100% - 2rem);
  height: 2.233333333333333rem;
  margin: 0.658333333333333rem 1rem;
  border: 1px solid #c5c5c5;
  border-radius: 1.108333333333333rem;
  overflow: hidden;
}
.friends-reset-item.shared-reset-item .name {
  width: 4.958333333333333rem;
  height: 2.233333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border: 1px solid #360ea6;
  background: #360ea6;
  border-radius: 1.108333333333333rem;
  font-size: 0.916666666666667rem;
  font-weight: normal;
}
.friends-reset-item.shared-reset-item:nth-child(2n) .name {
  background: #4b76b9;
  border: 1px solid #4b76b9;
}
.friends-reset-item.shared-reset-item .title {
  font-size: 0.916666666666667rem;
  height: 2.233333333333333rem;
  background: white;
  font-weight: bold;
  color: #360ea6;
  width: calc(100% - 14.958333333333333rem);
  justify-content: start;
  padding: 0 1rem;
}
.friends-reset-item.shared-reset-item .date {
  font-size: 0.833333333333333rem;
  height: 2.233333333333333rem;
  background: white;
  font-weight: normal;
  color: #808080;
  width: 10rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.public-shared-title {
  height: 3.275rem;
  width: 100%;
  background: rgba(244, 244, 244, 0.4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.108333333333333rem;
}
.public-shared-title img {
  width: 1.041666666666667rem;
}
.public-shared-title .title {
  background: transparent !important;
  color: #747474;
  font-weight: bold;
  width: calc(100% - 8.041666666666667rem);
  text-align: left;
  padding: 0 1rem;
  display: flex;
  justify-content: start;
}
.public-shared-reset-item {
  width: 100%;
}
.public-shared-reset-item .intake-rate {
  font-size: 1rem;
  font-weight: bold;
  color: #360ea6;
  width: 7rem;
  text-align: right;
}
.before-title,
.result-title {
  background: #4b76b9;
  border-radius: 0.766666666666667rem;
  color: white;
  width: 4.691666666666667rem;
  height: 1.541666666666667rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.691666666666667rem;
  clear: both;
  margin-bottom: 1.4rem;
}
.reset-images-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.4rem 1.275rem 0;
}
.reset-images {
  display: flex;
  justify-content: space-between;
}
.reset-images-container {
  width: calc(50% - 0.45rem);
}
</style>
